/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Tariff } from './Tariff'
import { TariffFromJSON, TariffFromJSONTyped, TariffToJSON } from './Tariff'
import type { HelpDataSiteCalc } from './HelpDataSiteCalc'
import {
  HelpDataSiteCalcFromJSON,
  HelpDataSiteCalcFromJSONTyped,
  HelpDataSiteCalcToJSON,
} from './HelpDataSiteCalc'

/**
 *
 * @export
 * @interface HelpDataSite
 */
export interface HelpDataSite {
  /**
   *
   * @type {string}
   * @memberof HelpDataSite
   */
  sourceUrl?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSite
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSite
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSite
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSite
   */
  comment?: string
  /**
   * Идентификатор клиента из UTM-трекинга (seo)
   * @type {string}
   * @memberof HelpDataSite
   */
  utmClientId?: string
  /**
   *
   * @type {Tariff}
   * @memberof HelpDataSite
   */
  tariff?: Tariff
  /**
   *
   * @type {HelpDataSiteCalc}
   * @memberof HelpDataSite
   */
  calc?: HelpDataSiteCalc
}

/**
 * Check if a given object implements the HelpDataSite interface.
 */
export function instanceOfHelpDataSite(value: object): value is HelpDataSite {
  return true
}

export function HelpDataSiteFromJSON(json: any): HelpDataSite {
  return HelpDataSiteFromJSONTyped(json, false)
}

export function HelpDataSiteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpDataSite {
  if (json == null) {
    return json
  }
  return {
    sourceUrl: json['sourceUrl'] == null ? undefined : json['sourceUrl'],
    name: json['name'] == null ? undefined : json['name'],
    phone: json['phone'] == null ? undefined : json['phone'],
    email: json['email'] == null ? undefined : json['email'],
    comment: json['comment'] == null ? undefined : json['comment'],
    utmClientId: json['utmClientId'] == null ? undefined : json['utmClientId'],
    tariff: json['tariff'] == null ? undefined : TariffFromJSON(json['tariff']),
    calc:
      json['calc'] == null ? undefined : HelpDataSiteCalcFromJSON(json['calc']),
  }
}

export function HelpDataSiteToJSON(value?: HelpDataSite | null): any {
  if (value == null) {
    return value
  }
  return {
    sourceUrl: value['sourceUrl'],
    name: value['name'],
    phone: value['phone'],
    email: value['email'],
    comment: value['comment'],
    utmClientId: value['utmClientId'],
    tariff: TariffToJSON(value['tariff']),
    calc: HelpDataSiteCalcToJSON(value['calc']),
  }
}
